import WhIllegalArgumentException from "./WhIllegalArgumentException";

class WhIllegalDateTimeException extends WhIllegalArgumentException {
  constructor(message) {
    super();
    this.message = message;
  }
}

export default WhIllegalDateTimeException



// WEBPACK FOOTER //
// ./src/assets/csui/parameter/WhIllegalDateTimeException.js